import {Box, HStack, ThemeColorPath} from 'platform/foundation';

interface RecordAuditProgressSegmentsProps {
  ok: number;
  bad: number;
  na: number;
  total: number;
}

const BAR_HEIGHT = 2;

interface SegmentSpec {
  count: number;
  color: ThemeColorPath;
}

// Stacked multi-colour progress bar (passed / failed / N-A over a neutral track
// for the not-filled remainder). Platform ProgressBar is single-severity only,
// so this is a small dedicated bar matching the mockup.
export function RecordAuditProgressSegments(props: RecordAuditProgressSegmentsProps) {
  const segments: SegmentSpec[] = [
    {count: props.ok, color: 'palettes.green.60.100'},
    {count: props.bad, color: 'palettes.red.60.100'},
    {count: props.na, color: 'palettes.neutral.70.100'},
  ];

  const toWidth = (count: number) =>
    props.total === 0 ? '0%' : (`${(count / props.total) * 100}%` as const);

  return (
    <Box
      height={BAR_HEIGHT}
      borderRadius="small"
      overflow="hidden"
      backgroundColor="palettes.neutral.40.100"
    >
      <HStack spacing={0}>
        {segments.map((segment) => (
          <Box
            key={segment.color}
            height={BAR_HEIGHT}
            width={toWidth(segment.count)}
            backgroundColor={segment.color}
          />
        ))}
      </HStack>
    </Box>
  );
}
